import {
  GLOBAL_NOTIFICATION_DISMISSED,
  GLOBAL_NOTIFICATION_REQUEST,
} from './GlobalNotificationActionType';

const initialState = {
  type: null,
  message: null,
  opened: false,
};

export default (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case GLOBAL_NOTIFICATION_REQUEST:
      return {
        ...state,
        type: payload.type,
        message: payload.message,
        opened: true,
      };
    case GLOBAL_NOTIFICATION_DISMISSED:
      return {
        ...state,
        opened: false,
      };
    default:
      return state;
  }
};
